module.exports = require('./dec/decode').BrotliDecompressBuffer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/brotli/decompress.js
// module id = 273
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/brotli/decompress.js